import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { StateStatus } from '@guryou/redux';

import { getAllMediaFiles } from '../new';

const useSharedMedia = type => {
  const dispatch = useDispatch();
  const { data, status, version, entity } = useSelector(state => state.files.sharedMedia);
  useEffect(() => {
    if (status === StateStatus.NOT_INITIALIZED) {
      dispatch(getAllMediaFiles());
    }
  }, [dispatch, status]);

  return { data: (data || []).filter(x => !type || x.type === type), status, version, entity };
};

export default useSharedMedia;
